<template>
    <div>
        <p>
            {{ introText }}
        </p>

        <validation-errors :error="error" />

        <form ref="form flex flex-col">
            <text-input
                v-model="ssid"
                :label="lang('Nätverksnamn (ssid)', 'Network name (ssid)')"
                name="ssid"
                :required="true"
                :autofocus="true"
            />

            <div class="grid">
                <div class="column w-full md:w-1/2">
                    <text-input
                        v-model="password"
                        :label="lang('Lösenord','password')"
                        type="password"
                        name="password"
                        :required="true"
                        :autofocus="true"
                    />
                </div>
                <div class="column w-full md:w-1/2">
                    <text-input
                        v-model="confirmPassword"
                        :label="lang('Upprepa lösenord','Confirm password')"
                        type="password"
                        name="confirm_password"
                        :required="true"
                        :autofocus="true"
                    />
                </div>
            </div>

            <div class="bg-neutral-lighter py-lg mt-lg px-xl -mx-2xl -mb-4xl">
                <div class="button-group">
                    <button
                        type="button"
                        class="btn is-ghost btn-lg"
                        @click="$emit('back')"
                    >
                        {{ lang('Tillbaka','Back') }}
                    </button>

                    <button
                        type="button"
                        class="btn btn-lg is-primary"
                        @click="save"
                    >
                        {{ lang('Spara inställningar','Save settings') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    import ValidationErrors from '../ValidationErrors';

    export default {
        components: {
            ValidationErrors,
        },
        data() {
            return {
                ssid: '',
                password: '',
                confirmPassword: '',
                introText: lang(
                    'Här väljer du ett eget namn på ditt nätverk och ett lösenord för det trådlösa nätverket.',
                    'Here you may enter a name for your network, and a password for the wireless network.'
                ),
                error: {},
            };
        },
        mounted() {
            this.$emit(
                'title',
                lang('Välj nätverksnamn och lösenord', 'Choose network name and password')
            );
        },
        methods: {
            async save() {
                this.loading = true;
                this.error = {};

                try {
                    const response = await axios.patch(
                        route('front.my-pages.api.router.update-wifi-settings'),
                        {
                            ssid: this.ssid,
                            password: this.password,
                            password_confirmation: this.confirmPassword,
                        }
                    );

                    if (response.data.error) {
                        this.error.push({ message: response.data.error });
                        return;
                    }

                    this.$emit('next');
                } catch (error) {
                    if (error.response.status === 401) {
                        this.error = {
                            message: lang(
                                'Din session har löpt ut, vänligen ladda om sidan och logga in igen.',
                                'Session expired, please reload the page and log in again.'
                            ),
                        };

                        return;
                    }

                    if (error.response.data.hasOwnProperty('errors')) {
                        this.error = error.response.data;
                        return;
                    }

                    this.error = {
                        message: lang(
                            'Vi kunde inte uppdatera din router. Var god kontakta kundtjänst om problemet kvarstår.',
                            'We could not update your router. Please contact customer support if the problem persists.',
                        ),
                    };
                }

                this.loading = false;
            },
        },
    };
</script>